import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
	page: number;
    ext_type: string;
    search_keyword: string;
    page_rows: number;
    order_by: string;
    is_desc: number;
    media_type: string;
    status_str: string;
}

export interface IMediaData {
    create_time: string;
    delete_time: string;
    ext: string;
    file_duration: string;
    file_name: string;
    file_size: string;
    id: string;
    id_prefix_type: string;
    id_prefix_value: string;
    is_deleted: string;
    is_live: string;
    is_recycle: string;
    live_session_id: string;
    live_session_status: string;
    live_session_url: string;
    live_session_url_flv: string;
    live_session_url_rtmp: string;
    live_vendor: string;
    media_type: string;
    regular_deleted_by_eid: string;
    status: string;
    stream_name: string;
    thumb_info: string;
    transcoding_ext: string;
    transcoding_rule_id: string;
    transcoding_url: string;
    update_time: string;
    url: string;
    vod_file_id: string;
    vod_transcoding_url: string;
}

export const getResourceArr = (data: IInput): Promise<IListResponse<IMediaData>> => {
	return fetchData(Api.GET_RESOURCE_ARR, data);
};

